import type { ReactNode } from 'react';

export function HelpDeskSectionTitle({ icon, children }: { icon: ReactNode; children: ReactNode }) {
  return <h3 className="help-desk__section-title">
    <span className="help-desk__section-title-icon" aria-hidden="true">{icon}</span>
    {children}
  </h3>;
}
